import {Component, inject, LOCALE_ID, OnInit, signal, viewChild } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { Observable, of } from 'rxjs';
import { filter, map, withLatestFrom } from 'rxjs/operators';

import { AuthService } from '@fry/lib/auth';
import { MenuIcon } from '@fry/components/common/buttons/buttons.list.component';
import { EASButtonAction, EASLinkAction } from '@fry/components/common/buttons';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MenuItem } from '@fry/lib/menu';
import { ClusterService, Organisation } from '@fry/lib/core/cluster.service';
import { OidcService } from '@fry/lib/core';
import { MatButton } from '@angular/material/button';
import { FryCommonModule } from '@fry/components/common';
import { UserLanguageService } from '@fry/components/users/user-language/user-language.service';

@Component({
    selector: 'app-portal-menu',
    templateUrl: './portal-menu.component.html',
    styleUrls: ['./portal-menu.component.scss'],
    standalone: true,
    imports: [
        RouterLink,
        MatSidenavModule,
        AsyncPipe,
        MatToolbarModule,
        MatButton,
        NgForOf,
        NgIf,
        FryCommonModule,
    ]
})
export class PortalMenuComponent implements OnInit {

  private drawer = viewChild(MatSidenav);

  menu = signal<MenuItem[]>([]);

  private router = inject(Router);
  private breakpointObserver = inject(BreakpointObserver);
  private cluster = inject(ClusterService);
  private oidc = inject(OidcService);
  private userLanguageService = inject(UserLanguageService);
  private locale = inject(LOCALE_ID);

  currentUser = this.oidc.currentUser;
  apiInfo = this.oidc.apiInfo;

  $org = signal<Organisation | null>(null);

  // Export MenuIcons enum to the template
  public MenuIcons = MenuIcon;

  languagesButtonsButtons: (EASButtonAction | EASLinkAction)[] = [];
  avatarButtons: (EASButtonAction | EASLinkAction)[] = [
    {
      type: 'button',
      label: $localize `Logout`,
      condition: () => {
        return of(true);
      },
      click: () => this.auth.startLogout(),

    }
  ];

  constructor(
    private auth: AuthService,
  ) {
    // console.log(this.clusterService.getCurrentOrganisation());
    const availableLanguages = this.userLanguageService.availableLanguages;
    console.log("Lang", availableLanguages);
    availableLanguages.forEach((lang) => {
      if (lang.languageCode === this.locale) {
        return;
      }
      this.languagesButtonsButtons.push({
        type: 'button',
        label: lang.languageName,
        condition: () => {
          return of(true);
        },
        click: () => {
          const newHref = this.userLanguageService.getLanguageBaseHref(lang.languageCode);
          window.location.href = `${newHref}${this.router.url}`;
        }
      });
    });

    this.router.events.pipe(
      withLatestFrom(this.isHandset$),
      filter(([a, b]) => b && a instanceof NavigationEnd)
    ).subscribe(_ => this.drawer()?.close());

  }

  isHandset$: Observable<boolean> = this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.HandsetPortrait])
    .pipe(
      map(result => result.matches)
  );

  ngOnInit() {
    console.log('Menu: Initialising menu');
    try {
      this.$org.set(this.cluster.getCurrentOrganisation());
    } catch (e) {
      console.error(e);
    }
  }

  login() {
    this.auth.startLogin();
  }

}
